import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const EditIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M11.7129 7.11396L8.88452 4.28554L2.16701 11.0031L1.53344 14.1709C1.49846 14.3458 1.65269 14.5 1.82762 14.465L4.99543 13.8315L11.7129 7.11396Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.2986 2.87132L13.127 5.69975L14.5412 4.28553C14.9318 3.89501 14.9318 3.26184 14.5412 2.87132L13.127 1.45711C12.7365 1.06658 12.1033 1.06658 11.7128 1.45711L10.2986 2.87132Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
));
